import Component from './account_add_dialog.vue'
export default Component
